export const GET_MODEL_BY_MODEL_ID_REQUEST =
  "GET_MODEL_BY_MODEL_ID_REQUEST";
export const GET_MODEL_BY_MODEL_ID_SUCCESS =
  "GET_MODEL_BY_MODEL_ID_SUCCESS";
export const GET_MODEL_BY_MODEL_ID_FAILURE =
  "GET_MODEL_BY_MODEL_ID_FAILURE";
